import { useState, useCallback, useRef, useEffect } from "react";
import { useFocusTrap } from "@thebouqs/hooks";
export default function useModal(params) {
  var {
    callback,
    open: paramsOpen,
    initialFocusRef,
    finalFocusRef,
    alignTo
  } = params;
  var modalIsOpen = useRef(false); // sets drawer state without refreshing (for animation)

  var modalRef = useRef(null);
  var [displayModal, setDisplayModal] = useState(typeof paramsOpen === "boolean" ? paramsOpen : false); // render drawer even if partially open

  var centerX = alignTo === "right" ? "50%" : "-50%"; // relay control to parent if needed

  var showModal = typeof paramsOpen === "boolean" ? paramsOpen : displayModal;
  var open = useCallback(() => {
    // transform in another thread to allow animation
    modalIsOpen.current = true;
    setDisplayModal(true);
    var el = modalRef.current;

    if (el) {
      setTimeout(() => {
        el.style.transform = "translateX(" + centerX + " ) translateY(-50%)";
        el.style.opacity = "1";
      }, 1);
    }
  }, [centerX]); // if you don't set it as useCallback, its dependents will register a change on each render

  var close = useCallback(() => {
    modalIsOpen.current = false;
    var el = modalRef.current;

    if (el) {
      el.style.transform = "translateX(" + centerX + " ) translateY(150vh)";
      el.style.opacity = "0";
    }
  }, [centerX]);
  var onModalRef = useCallback(node => {
    if (node !== null) {
      // lets the animation finish before toggling the modal off
      var onTransitionEnd = () => {
        if (modalIsOpen.current === false) {
          setDisplayModal(false);

          if (typeof callback === "function") {
            callback();
          }
        }
      };

      modalRef.current = node;
      var el = modalRef.current;
      el.addEventListener("transitionend", onTransitionEnd);
      el.focus();
    }
  }, [callback]);
  useEffect(() => {
    if (typeof paramsOpen === "boolean") {
      if (paramsOpen !== modalIsOpen.current) {
        if (paramsOpen) {
          open();
        } else {
          close();
        }
      }
    }
  }, [paramsOpen, open, close]);
  var onBlur = useFocusTrap({
    node: modalRef,
    initial: initialFocusRef,
    final: finalFocusRef,
    onClose: close,
    trap: displayModal
  });
  return {
    alignTo,
    isOpen: showModal,
    onOpen: open,
    onClose: close,
    onRef: onModalRef,
    mainProps: {
      role: "dialog",
      style: {
        transform: !showModal ? "translateX(" + centerX + ") translateY(150vh)" : "translateX(" + centerX + ") translateY(-50%)",
        opacity: showModal ? 1 : 0,
        display: showModal ? "block" : "none"
      },
      className: "modal-main",
      onBlur
    },
    triggerProps: {
      onClick: open
    },
    closeButtonProps: {
      className: "modal-close-button"
    },
    contentProps: {
      className: "modal-content"
    }
  };
}
//# sourceMappingURL=useModal.js.map